<template>
    <v-tooltip color="amber" :max-width="$attrs.maxWidth" :disabled="!text" right>
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <slot name="item"></slot>
            </span>
        </template>
        <div class="tooltip_ui" v-html="text"></div>
    </v-tooltip>
</template>

<script>
export default {
    props: ['text']
};
</script>

<style scoped>
.tooltip_ui {
    color: #000000;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
}
</style>
